import { createProductDraftFromMaster } from '../../store/products/createProductDraftFromMaster';
import readDraftDomains from '../../store/products/helpers/readDraftDomains';
import { selectDraftScopeChrome } from '../../store/selectors/draftScopeChromeSelectors';
import {
  selectChannelOptions,
  selectEffectiveChannelState,
} from '../../store/selectors/productSelectors';
import Logger from '../../services/Logger';
import {
  EDIT_DRAFT_TEXT_CANCEL,
  EDIT_DRAFT_TEXT_STRATEGY,
} from './editDraftTextStrategy';
import showHowDoYouWantToEditTextDialog from './showHowDoYouWantToEditTextDialog';

const startEditDraftTextFlow = async ({
  dispatch,
  getState,
  productId,
  variantId = null,
}) => {
  const state = getState();
  const chrome = selectDraftScopeChrome(state, productId, variantId);
  if (!chrome?.showEditText) return;

  const channelState = selectEffectiveChannelState(state, productId, variantId);
  const channelId = channelState.contextChannelId;
  if (!channelId) return;

  const channelOption = selectChannelOptions(state, productId)
    .find((option) => String(option.value) === String(channelId));
  if (!channelOption || channelOption.disconnected) return;

  const hasDraftText = Boolean(readDraftDomains(
    state.products,
    productId,
    variantId,
    channelId,
  )?.text);

  const strategy = await showHowDoYouWantToEditTextDialog({
    hasLive: Boolean(channelState.hasLive),
    hasDraftText,
  });

  if (!strategy || strategy === EDIT_DRAFT_TEXT_CANCEL) {
    return;
  }

  const text = strategy === EDIT_DRAFT_TEXT_STRATEGY.FROM_LIVE
    ? 'fromLive'
    : 'fromMaster';

  try {
    await dispatch(createProductDraftFromMaster({
      productId,
      channelIds: [channelId],
      ...(variantId ? { masterVariantIds: [variantId] } : { productOnly: true }),
      draftMedia: {
        publishingScope: { text, media: 'none' },
      },
    })).unwrap();
  } catch (error) {
    Logger.error(error, { error, productId, channelId }, [
      'EditDraftTextApplyFailed',
      { productId, channelId: String(channelId), text },
    ]);
  }
};

export default startEditDraftTextFlow;
